// extracted by mini-css-extract-plugin
export default {"secondayBtn":"SecondayBtn_secondayBtn__jl4u9"};